import { left, right } from 'fp-ts/Either';

import { httpClientFunction } from 'domain/types';
import ReadWidgetClient from 'use-case/widget/read/readWidgetClient';
import ReadWidgetCriteria from 'use-case/widget/read/readWidgetCriteria';
import { asWidget } from 'adapter/out/client/widgets/mappers/WidgetMapper';

export default (httpClient: httpClientFunction, baseUrl: string): ReadWidgetClient => (criteria: ReadWidgetCriteria) =>
    httpClient(`${baseUrl}/dashboards/widgets/${criteria.widgetId}`, {})
        .then((response) =>
            response.ok
                ? response
                      .json()
                      .then(asWidget)
                      .then(right)
                      .catch(() => left({ error: new Error(), status: 500 }))
                : left({ error: new Error(), status: response.status })
        )
        .catch(() => left({ error: new Error(), status: 503 }));
